"use client";
import {
  useSelectScopedContext
} from "../__chunks/6RJCEQC6.js";
import "../__chunks/X3ATWMYX.js";
import "../__chunks/KSMDNUGB.js";
import "../__chunks/7CRP5UGO.js";
import "../__chunks/SNQAYGW2.js";
import "../__chunks/P3UIANB7.js";
import {
  createElement,
  createHook,
  createMemoComponent
} from "../__chunks/LFJDOMBA.js";
import {
  useEvent,
  useId,
  useMergeRefs
} from "../__chunks/6WEF4WY5.js";
import "../__chunks/OZVWZODE.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/2SMRF6AD.js";

// src/select/select-label.ts
import { invariant } from "@ariakit/core/utils/misc";
var useSelectLabel = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const context = useSelectScopedContext();
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "SelectLabel must receive a `store` prop or be wrapped in a SelectProvider component."
    );
    const id = useId(props.id);
    const onClickProp = props.onClick;
    const onClick = useEvent((event) => {
      onClickProp == null ? void 0 : onClickProp(event);
      if (event.defaultPrevented)
        return;
      queueMicrotask(() => {
        const select = store == null ? void 0 : store.getState().selectElement;
        select == null ? void 0 : select.focus();
        select == null ? void 0 : select.click();
      });
    });
    props = __spreadProps(__spreadValues({
      id
    }, props), {
      ref: useMergeRefs(store.setLabelElement, props.ref),
      onClick,
      style: __spreadValues({
        cursor: "default"
      }, props.style)
    });
    return props;
  }
);
var SelectLabel = createMemoComponent((props) => {
  const htmlProps = useSelectLabel(props);
  return createElement("div", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  SelectLabel.displayName = "SelectLabel";
}
export {
  SelectLabel,
  useSelectLabel
};
